<div class="bottom-bar">
  <div class="icon-wrap" data-testid="bottom-bar-menu" (click)="onMenuClick()">
    <img class="icon-xl" [src]="'menu.svg' | themeSource" alt="menu"/>
  </div>
  @for (item of actions(); track item.source) {
    <div class="icon-wrap" [attr.data-testid]="'bottom-bar-' + item.source.action" (click)="onActionClick(item.source)">
      <img class="icon-xl" [src]="item.icon | themeSource" [alt]="item.source.action"/>
      @if (item.showBillBadge) {
        <span class="bill-badge" aria-hidden="true"></span>
      }
    </div>
    <img class="separator icon-xl" [src]="'line.svg' | themeSource" alt="separator"/>
  }
</div>
